import _ from 'lodash';
import { createSelector } from 'reselect';

import { selectUnderwriting } from './underwriting.selectors';

const selectUnderwritingDocExpirationSettings = createSelector(
  selectUnderwriting,
  ({ documentExpirationSettings }) => documentExpirationSettings,
);

export const selectUnderwritingDocExpirationSettingsValues = createSelector(
  selectUnderwritingDocExpirationSettings,
  settings =>
    Object.values(
      _.merge(
        {
          Appraisal: { documentExpirationDateType: 'Appraisal', expiresInDays: '' },
          Assets: { documentExpirationDateType: 'Assets', expiresInDays: '' },
          Credit: { documentExpirationDateType: 'Credit', expiresInDays: '' },
          Income: { documentExpirationDateType: 'Income', expiresInDays: '' },
        },
        settings,
      ),
    ),
);
